<img src="../../../assets/images/login-close.svg" alt="" mat-dialog-close="" (click)="close()" class="close-btn position-absolute">
<div class="scrollar">
    <div class="bg-c container-fluid">
        <div class="row">
            <div class="col">
                <div class="title fs-20 mb-2 wt fs-bold">
                    {{addData?.title}}
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="p-1" *ngIf="addData?.data?.key == 'countryMaster'">
                    <form [formGroup]="countryForm" *ngIf="countryForm">
                        <div class="form-floating mb-3">
                            <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Name *</mat-label>
                                <input matInput type="text" placeholder="Enter Name" formControlName="name"
                                appAlphabatesOnly>
                            </mat-form-field>
                            <span class="invalid-feedback mb-0"
                                *ngIf="(countryForm.get('name')?.touched  || countryForm.get('name')?.dirty) && countryForm.get('name')?.invalid">
                                Name is required *.
                            </span>
                            <div class="mt-2">
                                <ng-container>
                                    <h6 class="fs-16 fw-bold mb-3">Country image* </h6>
                                    <div class="receiptCard mt-2 mt-md-3">
                                        <div class="uploadContainer my-2" appDnd (fileDropped)="onFileDropped($event)">
                                            <div class="box">
                                                <input type="file"
                                                    accept="image/png, image/gif, image/jpeg" #fileDropRef id="fileDropRef"
                                                    formControlName='countryImage' (change)="fileBrowseHandler($event)" />
                                                <img src="../../../../assets/images/Image-upload.png" class="img-fluid mb-3"
                                                    style="max-width: 200px;" alt="">
                                                <div style="font-size:14px; font-weight:500; margin-top:10px;">Upload
                                                    Receipt/Screenshot
                                                </div>
                                                <div style="font-size: 12px;">
                                                    <label for="fileDropRef"
                                                        style="color:#131314; font-weight:500">Browse</label>
                                                    <span style="margin-left:4px; font-weight:500;">or Drag & Drop</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <p class="uploadFileInfo"><i>{{fileUploadInfo}}</i></p>
                                        </div><br>
                                        <div class="files-list mx-auto">
                                            <div class="single-file" *ngFor="let file of files; let i = index">
                                                <div class="file-icon" style="width: 50px">
                                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;"
                                                        xml:space="preserve">
                                                        <polygon style="fill:#EDEADA;"
                                                            points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
                                                        <g>
                                                            <path style="fill:#CEC9AE;"
                                                                d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
                                                            <path style="fill:#CEC9AE;"
                                                                d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
                                                        </g>
                                                        <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
                                                    </svg>
                                                </div>
                                                <div class="info">
                                                    <a style="text-decoration: none;" href="" target="_blank" class="name">
                                                        {{ file?.name ? file?.name : file?.file_Path}}
                                                    </a>
                                                    <div *ngIf="file?.progress">
                                                        <app-upload-progress
                                                            [progress]="file?.progress"></app-upload-progress>
                                                    </div>
                                                </div>

                                                <div class="delete" (click)="deleteFile(i)">
                                                    <img src="../../../../assets/images/delete-bin.svg" alt=""
                                                        style="cursor: pointer;">
                                                </div>

                                            </div>

                                        </div>
                                        <div *ngIf="isEditMode" class="d-flex">
                                            <img *ngIf="imgURL?.length" class="prefillImage"
                                                [src]="imgURL.includes('pdf') ? '../../../../assets/icons/pdfIcon.svg' : imgURL.includes('.docx') ? '../../../../assets/icons/msWordIcon.svg' : imgURL"
                                                alt="" (click)="openDocument()">
                                            <div *ngIf="imgURL?.length" [matTooltip]="'Delete'" class="delete ms-2" (click)="deleteFile(0)">
                                                    <img src="../../../../assets/images/delete-bin.svg" alt="" style="cursor: pointer;">
                                              </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="btn-c">
                            <button type="button" class="btn text-white rounded-pill signup-btn w-100"
                                (click)="createCountryForm()" [disabled]="countryForm.invalid">{{addData?.rowData ? 'Update'
                                : 'Create'}} </button>
                        </div>
                    </form>
                </div>
                <div class="p-1" *ngIf="addData?.data?.key == 'sectorMaster'">
                    <form [formGroup]="sectorForm" *ngIf="sectorForm">
                        <div class="form-floating mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Country Name *</mat-label>
                                <mat-select formControlName="country_id" placeholder="Select Country" aria-label="sector">
                                    <mat-option *ngFor="let item of countryList" [value]="item?.id">
                                        {{ item?.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="invalid-feedback mx-3 mb-0"
                                *ngIf="(sectorForm.get('country_id')?.touched  || sectorForm.get('country_id')?.dirty) && sectorForm.get('country_id')?.invalid">
                                Country Name is required *.
                            </span>
                        </div>
                        <div class="form-floating mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Sector Name *</mat-label>
                                <input matInput type="text" formControlName="name" placeholder="Enter Sector Name"
                                    appAlphabatesOnly>
                            </mat-form-field>
                            <span class="invalid-feedback mx-3 mb-0"
                                *ngIf="(sectorForm.get('name')?.touched  || sectorForm.get('name')?.dirty) && sectorForm.get('name')?.invalid">
                                Sector Name is required *.
                            </span>
                        </div>
                        <div class="btn-c">
                            <button type="button" class="btn text-white rounded-pill signup-btn w-100"
                                (click)="createSectorForm()" [disabled]="sectorForm?.invalid">{{addData?.rowData ? 'Update' :
                                'Create'}}</button>
                        </div>
                    </form>
                </div>
                <div class="p-1" *ngIf="addData?.data?.key == 'msmeMaster'">
                    <form [formGroup]="msmeForm" *ngIf="msmeForm">
                        <div class="mt-1">
                        <mat-form-field appearance="outline" class="form-floating  mb-3 w-100">
                            <mat-label>Country Name *</mat-label>
                            <mat-select formControlName="country_id" placeholder="Select Country"
                                (selectionChange)="countryChanges($event)">
                                <mat-option *ngFor="let item of countryList" [value]="item?.id">
                                    {{item?.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-error
                        *ngIf="(msmeForm.get('country_id')?.touched || msmeForm.get('country_id')?.dirty) && msmeForm.get('country_id')?.invalid">
                        Country Name is required *.
                    </mat-error>
                </div>

                        <div class="mt-1">
                        <mat-form-field appearance="outline" class="form-floating w-100 mb-3">
                            <mat-label>Sector Name *</mat-label>
                            <mat-select formControlName="sector_id" placeholder="Select Sector">
                                <mat-option *ngFor="let sectorItem of sectorList" [value]="sectorItem?.id">
                                    {{sectorItem?.name}}
                                </mat-option>
                            </mat-select>

                        </mat-form-field>
                        <mat-error
                        *ngIf="(msmeForm.get('sector_id')?.touched || msmeForm.get('sector_id')?.dirty) && msmeForm.get('sector_id')?.invalid">
                        Sector Name is required *.
                    </mat-error>
                    </div>

                        <div class="mt-1">
                        <mat-form-field appearance="outline" class="form-floating w-100 mb-3">
                            <input matInput type="text" formControlName="name" placeholder="Enter MSME Name"
                                appAlphanumericOnly>
                            <mat-label>MSME Name *</mat-label>

                        </mat-form-field>
                        <mat-error
                        *ngIf="(msmeForm.get('name')?.touched || msmeForm.get('name')?.dirty) && msmeForm.get('name')?.invalid">
                        MSME Name is required *.
                    </mat-error>
                    </div>
                        <div class="btn-c">
                            <button type="button" class="btn text-white rounded-pill signup-btn w-100"
                                (click)="createMsmeForm()" [disabled]="msmeForm?.invalid">{{addData?.rowData ?
                                'Update' : 'Create'}}</button>
                        </div>
                    </form>
                </div>

                <div class="p-1" *ngIf="addData?.data?.key == 'msmeClassificationMaster'">
                    <form [formGroup]="msmeClassificationForm" *ngIf="msmeClassificationForm">
                        <div formArrayName="rows">
                            <div class="table-responsive">
                                <table class="table table-borderless align-middle">
                                    <thead>
                                        <tr>
                                            <th>Enterprise Type</th>
                                            <th>Min Employees</th>
                                            <th>Max Employees</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                          *ngFor="let rowGroup of msmeClassRows.controls; let i = index"
                                          [formGroupName]="i"
                                        >
                                            <td>
                                                <mat-form-field appearance="outline" class="w-100 mb-0" style="cursor: not-allowed;">
                                                    <input
                                                      matInput
                                                      type="text"
                                                      formControlName="type"
                                                      placeholder="Enterprise Type"
                                                      appAlphabatesOnly
                                                      readonly
                                                      style="cursor: not-allowed;"
                                                    >
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline" class="w-100 mb-0" style="cursor: not-allowed;">
                                                    <input
                                                      matInput
                                                      type="number"
                                                      formControlName="min_employee_count"
                                                      min="1"
                                                      placeholder="Min Employees"
                                                      readonly
                                                      style="cursor: not-allowed;"
                                                    >
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline" class="w-100 mb-0">
                                                    <input
                                                      matInput
                                                      type="number"
                                                      formControlName="max_employee_count"
                                                      min="1"
                                                      placeholder="Max Employees"
                                                    >
                                                </mat-form-field>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="btn-c">
                            <button
                              type="button"
                              class="btn text-white rounded-pill signup-btn w-100"
                              (click)="createMsmeClassificationForm()"
                              [disabled]="msmeClassificationForm?.invalid || !msmeClassRows?.length"
                            >
                                Update
                            </button>
                        </div>
                    </form>
                </div>

                <div class="p-1" *ngIf="addData?.type == 'yearChange'">
                    <div class="form-floating mb-3">{{addData?.message}}</div>
                    <div class="">
                        <button type="button" class="btn text-white rounded-pill signup-btn w-100" (click)="closeDialog()">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>